import { useEffect } from 'react';

let lockCount = 0;
let savedHtmlOverflow = '';
let savedBodyOverflow = '';
let savedHtmlOverscroll = '';

function apply() {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  const body = document.body;
  if (lockCount === 0) {
    savedHtmlOverflow = html.style.overflow;
    savedBodyOverflow = body.style.overflow;
    savedHtmlOverscroll = html.style.overscrollBehavior;
  }
  lockCount += 1;
  html.style.overflow = 'hidden';
  body.style.overflow = 'hidden';
  html.style.overscrollBehavior = 'none';
}

function release() {
  if (typeof document === 'undefined') return;
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;
  const html = document.documentElement;
  const body = document.body;
  html.style.overflow = savedHtmlOverflow;
  body.style.overflow = savedBodyOverflow;
  html.style.overscrollBehavior = savedHtmlOverscroll;
}

/**
 * Reference-counted lock so nested overlays (e.g. modal + date dialog) stack safely.
 * @returns {() => void} release function
 */
export function acquireBodyScrollLock() {
  apply();
  return () => release();
}

/**
 * Lock page scroll while `locked` is true (e.g. modal/drawer open).
 */
export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    return acquireBodyScrollLock();
  }, [locked]);
}
